import {Component,OnInit} from '@angular/core';
import {FormulaireAvanceService} from './formulaire-avance.service';
import {BehaviorSubject} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";
import {TypeAv} from "@domain/admin/parametre/formulaire/param-avance";

/**
 * Composant d'affichage de la page formulaire des avances
 *
 * @author Lionel Gimenez
 * @date 18/09/2025
 */
@Component({
    host: {'data-test-id': 'formulaire-avance'},
    templateUrl: './formulaire-avance.component.html'
})
export class FormulaireAvanceComponent implements OnInit {
    /** Liste des actions */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /** Déclaration pour le template */
    TypeAv = TypeAv;

    /** Liste des options de la nature */
    listeOptionNature: Array<{ typeFact: number,libelle: string }>;

    /** Liste des options pour modeRapprochementDevise */
    listeModeRapprochementDeviseOption: Array<{ value: number,libelle: string }>;

    /**
     * Constructeur
     */
    constructor(
        public formulaireAvanceService: FormulaireAvanceService,
        private translateService: TranslateService
    ) {
    }

    /**
     * Hook initialisation
     */
    ngOnInit(): void {
        //Initialisation des listes d'options
        this.initOptionsListes();

        //Initialisation des actions
        this.initActions();

        //Chargement des données
        this.formulaireAvanceService.load();
    }

    /**
     * Initialise les listes d'options pour les sélecteurs
     */
    private initOptionsListes(): void {
        //Options pour modeRapprochementDevise basées sur les traductions
        this.listeModeRapprochementDeviseOption = [
            {
                value: 2,
                libelle: this.translateService.instant('admin.parametres.formulaire.avance.devise')
            },
            {
                value: 3,
                libelle: this.translateService.instant('admin.parametres.formulaire.avance.soldeDevise')
            },
            {
                value: 4,
                libelle: this.translateService.instant('admin.parametres.formulaire.avance.soldeAvance')
            }
        ];

        //Options pour la nature basées sur les traductions
        this.listeOptionNature = this.formulaireAvanceService.getListeNatureOption();
    }

    /**
     * Initialise les actions du bouton flottant
     */
    private initActions(): void {
        this.listeActions.next([
            {
                type: TypeAction.PRIMARY,
                icone: 'nio icon-sauvegarde',
                libelle: 'global.actions.enregistrer',
                doAction: () => this.save(),
            }
        ]);
    }

    /**
     * Sauvegarde les paramètres
     */
    save(): void {
        this.formulaireAvanceService.save();
    }

}
